(function () {
  "use strict";

  try {
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) {
    return;
  }

  var NEEDLE = "trendtrack";
  var HITS =
    '[data-trendtrack-floating-icon],[id*="trendtrack" i],[class*="trendtrack" i]';
  var FLAG = "data-ui-overlay-rule";
  var CSS =
    '[data-trendtrack-floating-icon],[id*="trendtrack" i],[class*="trendtrack" i]' +
    "{display:none !important;visibility:hidden !important;" +
    "opacity:0 !important;pointer-events:none !important;" +
    "transform:scale(0) !important;clip-path:inset(100%) !important;}";
  var WATCH_MS = 30000;
  var MAX_DEPTH = 5;
  var MAX_REMOVALS = 40;

  var pageRuleAdded = false;
  var scheduled = false;
  var stopped = false;
  var removals = 0;
  var observer = null;
  var timer = null;

  function addPageRule() {
    if (pageRuleAdded) return;

    var parent = document.head || document.documentElement;
    if (!parent) return;

    var style = document.createElement("style");
    style.setAttribute(FLAG, "");
    style.textContent = CSS;
    parent.appendChild(style);
    pageRuleAdded = true;
  }

  function kill(element) {
    if (!element || element.isConnected === false) return;

    var tag = element.tagName ? element.tagName.toLowerCase() : "";

    if (tag === "html" || tag === "head" || tag === "body" || tag === "script") {
      return;
    }

    removals++;

    try {
      element.innerHTML = "";

      if (element.remove) element.remove();
      else if (element.parentNode) element.parentNode.removeChild(element);
    } catch (e) {}

    if (removals >= MAX_REMOVALS) stop();
  }

  function scan(root, depth) {
    if (depth > MAX_DEPTH || removals >= MAX_REMOVALS) return;

    var hits = root.querySelectorAll(HITS);

    for (var h = 0; h < hits.length; h++) {
      kill(hits[h]);
      if (removals >= MAX_REMOVALS) return;
    }

    var elements = root.querySelectorAll("*");

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];

      if (element.isConnected === false) continue;
      if (removals >= MAX_REMOVALS) return;

      var tag = element.tagName;

      if (tag && tag.toLowerCase().indexOf(NEEDLE) !== -1) {
        kill(element);
        continue;
      }

      var shadow = element.shadowRoot;
      if (!shadow) continue;

      if (shadow.querySelector(HITS)) {
        kill(element);
        continue;
      }

      scan(shadow, depth + 1);
    }
  }

  function sweep() {
    if (stopped) return;

    try {
      addPageRule();
      scan(document, 0);
    } catch (e) {}
  }

  function schedule() {
    if (scheduled || stopped) return;

    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      sweep();
    }, 250);
  }

  function stop() {
    if (stopped) return;

    stopped = true;

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  sweep();

  if (typeof MutationObserver === "function") {
    observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  var elapsed = 0;
  timer = setInterval(function () {
    elapsed += 1000;
    sweep();
    if (elapsed >= WATCH_MS) stop();
  }, 1000);

  setTimeout(stop, WATCH_MS);
})();
